import { Button, FormGroup, Input, Label, Row, Textarea } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import { DataRow } from '@/pages/loginHist/loginHistMgmt'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col } from 'styled-bootstrap-grid'

const DetailLoginHistMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showConfirm } = useDialog()
  const { getComCodeValue } = useRedis();

  const [data, setData] = useState<DataRow | null>(null)

  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    getLoginHistDetail()
  }, [])

  const getLoginHistDetail = async () => {
    try {
      const response = await axios.get('/loginHistMgmt/detail', {
        params: {
          // userId: location.state.userId,
          adminYn: 'N',
          histSn: location.state.histSn || '',
        },
      })
      const data = response.data.data?.histDetail

      if(data){
        data.loginYnNm = getComCodeValue('LOGIN_YN', data.loginYn)?.codeNm || '';
        setData(data)
      }

    } catch (error) {
      console.error('Error fetching histDetail:', error)
    }
  }

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ fontSize: '20px' }}>로그인이력 - 상세</p>
          <div style={{ marginLeft: 'auto' }}>
            <Button
              onClick={() =>
                showConfirm({
                  title: '목록으로 이동할까요?',
                  onConfirm() {
                    navigate('/loginHistMgmt', {
                      state: {
                        loginHistSearchState:
                          location.state?.loginHistSearchState,
                        memberSearchState: location.state?.memberSearchState,
                      },
                    })
                  },
                })
              }
              color="neverbe"
              variant="outlined"
            >
              목록
            </Button>
          </div>
        </div>
      </div>
      <div style={{ marginTop: '20px' }}>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                순번
              </Label>
              <Input
                id="histSn"
                name="histSn"
                type="text"
                disabled={true}
                value={data?.histSn || ''}
              />
            </FormGroup>
          </Col>

          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                ID{' '}
              </Label>
              <Input
                id="userId"
                name="userId"
                type="text"
                disabled={true}
                value={data?.userId || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                접속IP
              </Label>
              <Input
                id="accessIp"
                name="accessIp"
                type="text"
                disabled={true}
                value={data?.accessIp || ''}
              />
            </FormGroup>
          </Col>

          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                로그인성공여부{' '}
              </Label>
              <Input
                id="loginYn"
                name="loginYn"
                type="text"
                disabled={true}
                value={data?.loginYnNm || data?.loginYn || ''}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                로그인결과코드{' '}
              </Label>
              <Input
                id="loginFailCode"
                name="loginFailCode"
                type="text"
                disabled={true}
                value={data?.loginFailCode || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="msgCd">
                로그인이력메시지{' '}
              </Label>
              <Textarea
                id={'loginHistMessage'}
                name={'loginHistMessage'}
                value={data?.loginHistMessage || ''}
                disabled={true}
                ref={textareaRef}
                height={'500px'}
              ></Textarea>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <Input
                id="regId"
                name="regId"
                maxLength={20}
                value={data?.regId || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                등록일시
              </Label>
              <Input
                id="regDate"
                name="regDate"
                maxLength={20}
                value={
                  (data?.regDate &&
                    commonUtils.formatDate(data?.regDate, true)) ||
                  ''
                }
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <Input
                id="updId"
                name="updId"
                maxLength={20}
                value={data?.updId || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <Input
                id="updDate"
                name="updDate"
                maxLength={20}
                value={
                  (data?.regDate &&
                    commonUtils.formatDate(data?.regDate, true)) ||
                  ''
                }
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  )
}
export default DetailLoginHistMgmt
